var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.facebook.ref,staticClass:"fb-customerchat",attrs:{"page_id":_vm.facebook.page_id,"data-href":_vm.facebook['data-href'],"messenger_app_id":_vm.facebook.messenger_app_id,"theme_color":_vm.facebook.theme_color}})
}
var staticRenderFns = []

export { render, staticRenderFns }